import { Radio } from "antd";
import { cloneDeep, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import "./style.less";
import { language } from "@/utils/language";
const optionStyle = {
  textAlign: "center",
  width: "25%",
  marginBottom: 4,
  paddingTop: 4,
};

const Row = ({ option, option1, option2, onChange, checked }) => (
  <div className="maxdiff-row">
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={optionStyle}>
        <Radio
          style={{ transform: "scale(1.3)" }}
          value={true}
          checked={checked === true}
          onChange={() => onChange(option1, true)}
        />
      </div>
      <div
        style={{ width: "50%", textAlign: "center", paddingTop: 5 }}
        dangerouslySetInnerHTML={{
          __html: option.description
            .replace(/<p><\/p>/g, "<br />")
            .replace(/\n\n/g, "<br />")
            .replace(/\s{2}/g, "&nbsp;&nbsp;"),
        }}
      />
      <div style={optionStyle}>
        <Radio
          style={{ transform: "scale(1.3)" }}
          value={false}
          checked={checked === false}
          onChange={() => onChange(option2, false)}
        />
      </div>
    </div>
  </div>
);

const RowTitle = ({ questions: [quet1, quet2] }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      marginBottom: 20,
    }}
  >
    <div
      style={optionStyle}
      dangerouslySetInnerHTML={{
        __html: quet1.description
          .replace(/<p><\/p>/g, "<br />")
          .replace(/\n\n/g, "<br />")
          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
      }}
    />
    <div style={{ width: "50%" }} />
    <div
      style={optionStyle}
      dangerouslySetInnerHTML={{
        __html: quet2.description
          .replace(/<p><\/p>/g, "<br />")
          .replace(/\n\n/g, "<br />")
          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
      }}
    />
  </div>
);

const id2code = (id, options) => options.find((o) => o.id == id).codeValue;
const code2id = (code, options) => options.find((o) => o.codeValue == code).id;
const idIsSelected = (id, obj) => {
  try {
    const keys = Object.keys(obj);
    const a1 = Object.keys(obj[keys[0]])[0];
    if (a1 === id) return true;
    const a2 = Object.keys(obj[keys[1]])[0];
    if (a2 === id) return true;
    return false;
  } catch {
    return false;
  }
};

export default (props) => {
  const { info, answer, changeAnswer } = props;
  const { childs, options } = info;
  const [record, setRecord] = useState({});

  useEffect(() => {
    try {
      if (isEmpty(record)) {
        const obj = answer[info.id];
        const keys = Object.keys(obj);
        const a1 = Object.keys(obj[keys[0]])[0];
        const a2 = Object.keys(obj[keys[1]])[0];
        setRecord({
          [childs[0].id === keys[0]]: a1,
          [childs[1].id === keys[0]]: a2,
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  }, [answer]);

  if (childs.length < 2) {
    return <div>{language().modal_ok}</div>;
  }

  const changeRadio = (option, value) => {
    const [quet1, quet2] = childs;
    if (isEmpty(answer)) {
      changeAnswer({
        [value ? quet1.id : quet2.id]: {
          [option.id]: null,
        },
      });
      setRecord({ [value]: option.id });
    } else {
      const newAnswer = cloneDeep(answer[info.id]);
      const questionId = quet1.id;
      const _questionId = quet2.id;
      const options1 = childs[0].options;
      const options2 = childs[1].options;
      const currentSelectedCode = id2code(
        option.id,
        value ? options1 : options2
      );
      console.log(questionId, _questionId);
      if (value) {
        console.log(true);
        newAnswer[questionId] = { [option.id]: null };
        const falseId = code2id(currentSelectedCode, options2);
        console.log(falseId);
        if (idIsSelected(falseId, answer[info.id])) {
          console.log("selected");
          delete newAnswer[quet2.id];
          setRecord({ true: option.id });
        } else {
          setRecord((old) => ({ ...old, true: option.id }));
        }
      } else {
        console.log(false);
        newAnswer[_questionId] = { [option.id]: null };
        const trueId = code2id(currentSelectedCode, options1);
        if (idIsSelected(trueId, answer[info.id])) {
          delete newAnswer[quet1.id];
          setRecord({ false: option.id });
        } else {
          setRecord((old) => ({ ...old, false: option.id }));
        }
      }
      changeAnswer(newAnswer);
    }
  };

  return (
    <div style={{ padding: "0 10px" }}>
      <RowTitle questions={childs} />
      {options.map((option) => {
        const { id } = option;
        let checked;
        const options1 = childs[0].options;
        const options2 = childs[1].options;
        const option1 = options1.find(
          (item) => item.codeValue === option.codeValue
        );
        const option2 = options2.find(
          (item) => item.codeValue === option.codeValue
        );
        if (record["true"] && record["true"] === option1.id) {
          checked = true;
        }
        if (record["false"] && record["false"] === option2.id) {
          checked = false;
        }
        return (
          <Row
            key={id}
            option={option}
            option1={option1}
            option2={option2}
            checked={checked}
            onChange={changeRadio}
          />
        );
      })}
    </div>
  );
};
